import styled from 'styled-components';

export const StyledLink = styled.a<{ $underline?: boolean }>`
  cursor: pointer;
  color: ${({ theme }): string => theme.admanColors!.blue.dark.bg1[0]};
  text-decoration: ${({ $underline }): string => ($underline ? 'underline 1px' : 'none')};
`;
